import { MODALS } from '~/shared/constants/modals';
import { closeResponsiveModal, openResponsiveModal } from '~/shared/ui/ResponsiveModals';
import { type AppealProps } from '../Appeal';

export const openAppealModal = (props: AppealProps) => {
    openResponsiveModal({
        modalId: MODALS.PAYIN_ORDER_APPEAL,
        modal: MODALS.PAYIN_ORDER_APPEAL,
        title: 'Апелляция ордера',
        innerProps: {
            ...props,
            onSuccess: () => {
                closeResponsiveModal(MODALS.PAYIN_ORDER_APPEAL);
                props.onSuccess?.();
            },
            onCancel: () => {
                closeResponsiveModal(MODALS.PAYIN_ORDER_APPEAL);
            },
        },
    });
};
